import { Paper, LoadingOverlay, Group, Text, Button, Table } from '@mantine/core';

export default function FeedbackSettingsSection({
  loading,
  activeTab,
  feedbacks,
  fetchFeedback,
}) {
  return (
    <Paper withBorder p="md" radius="md" mt="xs" pos="relative">
      <LoadingOverlay visible={loading && activeTab === 'feedback'} overlayProps={{ radius: 'sm', blur: 2 }} />

      <Group justify="space-between" mb="md">
        <Text fw={700}>Gelen Mesajlar</Text>
        <Button size="xs" onClick={fetchFeedback}>Yenile</Button>
      </Group>

      <Table striped highlightOnHover withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Kullanıcı</Table.Th>
            <Table.Th>Mesaj</Table.Th>
            <Table.Th>Tarih</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {feedbacks.map((msg) => (
            <Table.Tr key={msg.id}>
              <Table.Td>{msg.user?.full_name || msg.user?.username || 'Anonim'}</Table.Td>
              <Table.Td>{msg.message}</Table.Td>
              <Table.Td>{new Date(msg.created_at).toLocaleString()}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}